<template>
<v-dialog v-model="dialogCreateTask" persistent max-width="720" class="CSChatThai">
  <v-card>
    <v-card tile flat>
      <v-toolbar card class="toolbar-card-v2">
        <v-toolbar-title class="CSChatThai">
          {{$t('Task.create.header')}}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon flat @click="closeDialog">
          <v-icon style="color: black !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
      <!-- <v-system-bar class="system-bar"></v-system-bar> -->
    </v-card>
    <v-card-text  class="CSChatThai" style="overflow-y: scroll;height: 70vh;">
        <v-layout column wrap>
          <v-flex sm3 md3 xl3 lg3 class="textSubject">
            <span>{{$t('Task.create.subject')}}<span style="color: red;">*</span> :</span>
          </v-flex>
          <v-flex sm9 md9 xl9 lg9 style="margin-top: 10px;">
            <input type="text" :placeholder="$t('Task.create.placeholderSubject')" class="CSChatThai inputtaskweb" v-model="subject_task">
          </v-flex>
          <v-flex sm3 md3 xl3 lg3 class="textSubject">
            <span>{{$t('Task.create.priority')}} :</span>
          </v-flex>
          <v-flex sm8 md8 xl8 lg8 style="margin-top:20px;">
              <v-btn flat :class="(priority=='1')? 'selectedPriority': ''" style="text-transform: none;" @click="priority = '1';">
                <v-icon class="btn-pri1">mdi-checkbox-blank</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;{{$t('Task.create.p1')}}
              </v-btn>
              <v-btn flat :class="(priority=='2')? 'selectedPriority': ''" style="text-transform: none;" @click="priority = '2';">
                <v-icon class="btn-pri2">mdi-checkbox-blank</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;{{$t('Task.create.p2')}}
              </v-btn>
              <v-btn flat :class="(priority=='3')? 'selectedPriority': ''" style="text-transform: none;" @click="priority = '3';">
                <v-icon class="btn-pri3">mdi-checkbox-blank</v-icon>&nbsp;&nbsp;&nbsp;&nbsp;{{$t('Task.create.p3')}}
              </v-btn>
          </v-flex>
          <v-flex sm3 md3 xl3 lg3 class="textSubject">
            <span>{{$t('Task.create.startDate')}}<span style="color: red;">*</span> :</span>
          </v-flex>
          <v-flex sm9 md9 xl9 lg9>
            <v-menu
                ref="menu1"
                :close-on-content-click="false"
                v-model="menu1"
                :nudge-right="40"
                :return-value.sync="start_date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                style="width: 100%;"
              >
              <v-text-field
                slot="activator"
                v-model="start_date"
                label=""
                readonly
              ></v-text-field>
              <v-date-picker
                v-model="start_date"
                no-title scrollable
                :allowed-dates="allowedDates"
                >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menu1 = false" style="text-transform: none;">
                  {{$t('AnswerQuestion.cancel')}}
                </v-btn>
                <v-btn flat color="primary" @click="$refs.menu1.save(start_date)" style="text-transform: none;">
                  {{$t('AnswerQuestion.ok')}}
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3 md3 xl3 lg3 class="textSubject">
            <span>{{$t('Task.create.endDate')}}<span style="color: red;">*</span> :</span>
          </v-flex>
          <v-flex sm9 md9 xl9 lg9>
            <v-menu
                ref="menu2"
                :close-on-content-click="false"
                v-model="menu2"
                :nudge-right="40"
                :return-value.sync="end_date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                style="width: 100%;"
              >
              <v-text-field
                slot="activator"
                v-model="end_date"
                label=""
                readonly
              ></v-text-field>
              <v-date-picker
              v-model="end_date"
              no-title
              scrollable
              :allowed-dates="allowedDatesEnd"
              :min="min_date_end"

              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menu2 = false" style="text-transform: none;">
                  {{$t('AnswerQuestion.cancel')}}
                </v-btn>
                <v-btn flat color="primary" @click="$refs.menu2.save(end_date)" style="text-transform: none;">
                  {{$t('AnswerQuestion.ok')}}
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3 md3 xl3 lg3 class="textSubject">
            <span>{{$t('Task.create.description')}} :</span>
          </v-flex>
          <v-flex sm9 md9 xl9 lg9 style="margin-top: 20px;">
            <v-textarea
              :label="$t('Task.create.placeholderDescription')"
              solo
              no-resize
              style="width: 100%;"
              outline
              height="80"
              rows=3
              hide-details
              v-model="detail_task"
            ></v-textarea>
          </v-flex>
          <v-flex sm3 md3 xl3 lg3 class="textSubject">
            <span>{{$t('Task.create.assign')}} :</span>
          </v-flex>
          <v-flex sm9 md9 xl9 lg9>
            <v-autocomplete
              :items="member"
              v-model="selectemember"
              :label="$t('Task.create.placeholderAssign')"
              item-text="name"
              item-value="tokenuser"
              multiple
              chips
              max-height="auto"
              style=" width: 75%;"
            >
              <template slot="selection" slot-scope="data">
                <v-chip
                  :selected="data.selectemember"
                  :key="JSON.stringify(data.item)"
                  close
                  class="chip--select-multi"
                  @input="data.parent.selectItem(data.item)"
                  v-if="data.item.type !== 'bot'"
                >
                  <v-avatar>
                    <img v-if="data.item.profilepicture" :src="data.item.profilepicture" class="object-fit-img">
                    <img v-else-if="data.item.type === 'company'" src='/static/img/default_profile/business-white.png' class="object-fit-img">
                    <img v-else-if="data.item.type === 'government'" src='/static/img/default_profile/business-white.png' class="object-fit-img">
                    <img v-else-if="data.item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="object-fit-img">
                    <img v-else src='/static/img/default_profile/man-white.png' class="object-fit-img">
                  </v-avatar>
                  <p class="text-overflow-chip">{{ data.item.name }}</p>
                </v-chip>
              </template>
              <template slot="item" slot-scope="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>
                  <v-list-tile-avatar v-if="data.item.type !== 'bot'">
                    <img v-if="data.item.profilepicture" :src="data.item.profilepicture" class="object-fit-img">
                    <img v-else-if="data.item.type === 'company'" src='/static/img/default_profile/business-white.png' class="object-fit-img">
                    <img v-else-if="data.item.type === 'government'" src='/static/img/default_profile/business-white.png' class="object-fit-img">
                    <img v-else-if="data.item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="object-fit-img">
                    <img v-else src='/static/img/default_profile/man-white.png' class="object-fit-img">
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title v-if="data.item.type !== 'bot'" class="text-overflow">{{data.item.name}}</v-list-tile-title>
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex sm3 md3 xl3 lg3 class="textSubject">
            <span>{{$t('Task.create.status')}} :</span>
          </v-flex>
          <v-flex sm9 md9 xl9 lg9 style="margin-top:20px;">
            <v-select
            :items="state"
            v-model="state_id"
            outlined
            hide-details
            item-text="name"
            item-value="state_id"
            style="padding:0; width: 25%;"
          ></v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap align-end justify-center class="" style="margin-top: 15px;">
          <v-btn class="btncancle" @click="cancel_task()">{{$t('AnswerQuestion.cancel')}}</v-btn>
          <v-btn class="btncreate" @click="add_task()" :loading="isloading"
          :disabled="subject_task == '' || priority == undefined || start_date == '' || end_date == ''">{{$t('AnswerQuestion.ok')}}</v-btn>
        </v-layout>
    </v-card-text>
  </v-card>
</v-dialog>
</template>
<script>
import { Decode } from '@/services'
// import DateRangePicker from 'vue2-daterange-picker'
// import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
var _ = require('lodash')
export default {
  props: {
    dialogCreateTask: false,
    projectid: ''
  },
  data: () => ({
    detail_task: '',
    token: '',
    subject_task: '',
    radios: '1',
    menu1: false,
    menu2: false,
    start_date: new Date().toISOString().substr(0, 10),
    end_date: new Date().toISOString().substr(0, 10),
    min_date: '',
    max_date: '',
    priority: '1',
    member: [],
    state: [],
    state_id: '',
    selectemember: [],
    subject_taskRules: [
      v => !!v || 'กรุณากรอกหัวข้อการ์ดงาน',
    ],
    isloading: false,
    min_date_end: '',
    max_date_end: ''
    // dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10))
  }),
  components: {
    // DateRangePicker
  },
  created () {
    var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
  },
  mounted () {
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    }
  },
  watch: {
    dialogCreateTask () {
      // console.log(this.dialogCreateTask)
      if (this.dialogCreateTask) {
        this.getroom()
        this.getstate()
      }
    }
  },
  methods: {
    allowedDates (val) {
      this.min_date_end = this.start_date
      if (this.start_date > this.end_date) {
        this.end_date = this.start_date
      }
      return this.min_date_end
    },
    allowedDatesEnd (val) {
      this.min_date_end = this.start_date
      if (this.min_date_end > this.end_date) {
        this.end_date = this.min_date_end
      }
      return this.end_date
    },
    closeDialog () {
      this.selectemember = []
      this.priority = '1'
      this.detail_task = ''
      this.subject_task = ''
      this.start_date = new Date().toISOString().substr(0, 10),
      this.end_date = new Date().toISOString().substr(0, 10),
      this.$emit('closeCreateTask', false)
    },
    getstate () {
      this.axios.post(process.env.APIpub + '/v1/user/get_state_by_project', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid,
        project_id: this.projectid
      }).then((response) => {
        this.state = response.data.data.state
        this.state_id = response.data.data.state[0].state_id
      }).catch(error => {
        console.log(error.message)
      })
    },
    cancel_task () {
      this.$swal({
        text: this.$t('Alert.Task.removeData'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.selectemember = []
          this.priority = '1'
          this.detail_task = ''
          this.subject_task = ''
          this.start_date = new Date().toISOString().substr(0, 10),
          this.end_date = new Date().toISOString().substr(0, 10)
        }
      })
    },
    add_task () {
      this.isloading = true
      this.axios.post(process.env.APIpub + '/v1/user/create_task', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid,
      	title: this.subject_task,
      	detail: this.detail_task,
      	state_id: this.state_id,
      	time_start: this.start_date + ' 00:00:00',
      	time_end: this.end_date + ' 00:00:00',
      	priority: this.priority,
      	project_id: this.projectid,
      	assign: this.selectemember
      }).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data.data.task_id)
          this.isloading = false
          this.$swal('', this.$t('Alert.Success.createTask'), 'success')
          this.$emit('createdtask', {'task_id': response.data.data.task_id, 'state_id': this.state_id, 'event': 'create'})
          this.closeDialog()
        }
      }).catch(error => {
        console.log(error.message)
      })
    },
    getroom () {
      this.axios.post(process.env.APImanage + '/getroom', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      }).then((response) => {
        if (response.data.status === 'success') {
          var member_active = []
          member_active = response.data.data_room
          this.member = _.filter(member_active, function(o) { return o.type !== 'bot' && o.statemember == 'active' })
          this.member.push({
            tokenuser: this.token,
            name: localStorage.getItem('name'),
            profilepicture: localStorage.getItem('profilepicture')
          })
        }
      }).catch(error => {
        console.log(error.message)
      })
    }
  }
}
</script>
<style type="text/css" scoped>
.object-fit-img {
  object-fit: cover;
  object-position: 50% 0;
}
>>>.v-input .v-label {
  height: 25px !important;
  line-height: 24px !important;
}
>>>.v-text-field--outline .v-input__slot {
  min-height: 50px !important;
}
.system-bar {
  height: 3px !important;
  border-radius: 10px !important;
  width: 250px !important;
  margin-left: 10px !important;
  background-color: #d8d8d8 !important;
}
>>>.v-btn-toggle--selected {
  box-shadow: none !important;
}
.text-overflow-chip {
  margin-top: 10px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 50px !important;
}
.text-overflow {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 250px !important;
}
.selectedPriority {
 border-radius: 5px;
 border: 1px solid #979797;
}
.btn-pri1 {
  /*width: 80px !important;*/
  color: #b3493d !important;
  font-size: 34px !important;
  /*border-radius: 4px !important;*/
}
.btn-pri2 {
  /*width: 80px !important;*/
  color: #fcbe55 !important;
  font-size: 34px !important;
  /*border-radius: 4px !important;*/
}
.btn-pri3 {
  /*width: 80px !important;*/
  color: #a0a1a3 !important;
  /*border-radius: 4px !important;*/
  font-size: 34px !important;
}
>>>.v-input__slot {
  border-radius: 6px !important;
  /* border-color: #949494 !important;
  border-style: solid !important;
  border-width: thin !important; */
  border-width: thin !important;
  box-shadow: none !important;
}
.height-600px {
  height: 600px !important;
}
.toolbar-card {
  background-color: #1e2227 !important;
}
.toolbar-card-v2 {
  background-color: white !important;
}
.btncreate {
  font-weight: 700;
  font-size: 13px !important;
  border-radius: 30px !important;
  margin-left: 0vw !important;
  margin-right: 15px!important;
  /* background: #2562af !important; */
  background-image: linear-gradient(to right, rgb(66, 104, 251), rgb(113, 186, 200)) !important;
  color: white !important;
  width: 90px !important;
  text-transform: none;
}
.btncancle {
  font-size: 13px !important;
  border-radius: 30px !important;
  margin-left: 0vw !important;
  margin-right: 10px !important;
  background: #ffffff !important;
  color: #4268fb !important;
  width: 90px !important;
  border-style: solid !important;
  border-color: #4268fb !important;
  box-shadow: none !important;
  text-transform: none;
}
.text2 {
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.close-classic:after {
  content: '×';
  font-size: 20px;
  /* ANSI X letter */
}

.containers {
  width: 454px;
  margin: 0 auto;
}

.containers:after {
  content: '';
  display: block;
  clear: both;
}
.listfile {
  overflow-x: scroll !important;
  overflow-y: hidden !important;
  height: 135px !important;
  display: -webkit-inline-box !important;
  background: #f3f2f2 !important;
  padding-top: 17px !important;
  border-radius: 10px !important;
  margin-bottom: 15px !important;
  margin-top: 20px;
}

.borderfile {
  border: 1px solid #00000036;
  border-radius: 5px;
  width: 140px !important;
  height: 100px !important;
  position: relative;
  background: white;
}

.Kanit {
  font-family: 'Kanit', sans-serif !important;
}

.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}

.application .theme--light.input-group input,
.application .theme--light.input-group textarea,
.theme--light .input-group input,
.theme--light .input-group textarea {
  /* color: rgba(0,0,0,.87); */
  color: #53ceff !important;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.user-photonote {
  height: 40px !important;
  width: 40px !important;
  background: #ccc;
  border-radius: 50%;
  overflow: hidden;

}

.textchat {
  white-space: nowrap;
  max-width: 9em;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'CS ChatThaiUI' !important;
  text-transform: none;
  display: inline-flex;
}

input[type=text] {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #b7b7b7;
  border-radius: 30px;
  font-size: 16px;
  background-color: white;
  background-image: url('/static/img/default_profile/group-white.png');
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 12px 20px 12px 20px;
  -webkit-transition: width 0.4s ease-in-out;
  transition: width 0.4s ease-in-out;
}
input[type=text]:focus {
    outline: none !important;
}
>>>.v-input .v-label {
    height: 20px;
    line-height: 24px;
}
>>>.trix-content {
    height: 220px !important;
}
>>>trix-editor:empty:not(:focus)::before {
    content: attr(placeholder);
    color: #858585;
    font-size: 16px;
    cursor: text;
}
>>>.trix-button-group--file-tools {
  display: none;
}
.attachment_file {
  border-radius: 3px;
  border: #bbbbbb 1px solid;
  background: #eee;
  width: fit-content;
  padding-left: 5px;
  padding-right: 5px;
  display: inline-block;
}
>>>.inputtaskweb {
  color: black !important;
  font-size: 16px !important;
  height: 40px;
  width: 100% !important;
  border-radius: 5px !important;
  border: 1px #979797 solid !important;
}
.textSubject {
  margin-top: 10px;
  text-align: left;
  padding-right: 20px;
  font-size: 16px;
}
input[type=text]:focus {
    outline: none !important;
}
textarea[type=text]:focus {
    outline: none !important;
}
.InputEdit {
    height: 43px;
    width: 100%;
    padding: 5px 15px !important;
    background-color: #fff;
    border: 1px solid #d2d8dd;
    border-radius: 4px;
    margin-bottom: 15px !important;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
    border: 1px #979797 solid;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/task/created_task_dialog_mo.vue